export default __webpack_public_path__ + "static/media/walking-parents.8387b1ee.svg";